import { DnDStageMapping } from '@forwardflow/features'
import { useGetStageMapping } from '@forwardflow/queries/stage-mapping.queries'
import { StageMappingService } from '@forwardflow/services/stage-mapping.service'
import { IStageMapGroup } from '@forwardflow/types/onboarding'

const StageMapping = () => {
   const { data: stageMapping } = useGetStageMapping()

   return (
      <div className="flex flex-col flex-1 h-full overflow-hidden">
         <div className="flex items-center justify-between h-20 pl-8 pr-4 bg-white/5 shrink-0">
            <span className="text-lg font-medium">Stage Mapping</span>
         </div>

         <div className="flex-1 overflow-y-auto">
            <div className="flex flex-col p-6 gap-y-6">
               <DnDStageMapping
                  initialStageMappingGroups={stageMapping || []}
                  onSaveStageMappingGroups={(groups) => {
                     StageMappingService.updateStageMapping({ stageMapping: groups as IStageMapGroup[] })
                  }}
                  autoSave
                  showNavigation={false}
               />
            </div>
         </div>
      </div>
   )
}

export default StageMapping
